import React, { Component } from 'react';
import { Grid,Row,Col,Modal,Button,Image,Clearfix } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import './Cards.css';
import { API_ROOT } from '../../config.js';
import spinner from '../Header/Spinner-1s-150px.svg';
import {Helmet} from 'react-helmet'

class Cards extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cardList: [],
      categoryName: null,
      categoryDesc: null,
      cardList100: [],
      cardList110: [],
      cardList120: [],
      cardList125: [],
      cardList150: [],
      cardList170: [],
      cardList200: [],
      cardList300: [],
      cardList400: [],
      cardList500: [],
      cardList550: [],
      cardList600: [],
      cardList650: [],
      cardList670: [],
      cardList700: [],
      cardList800: [],
      cardList900: [],
      lcShow: false,
      lcImage: "",
      lcLink: "",
      lcName: "",
      lcPrice: "",
      lcCategoryId: 0,
      isLoading: true
    }
  }

  shouldComponentUpdate(nextprops, nextstate) {
    if(nextprops.categoryid !== this.props.categoryid) {
      this.fetchCardList(nextprops.categoryid);
    }
    if(nextprops.categ !== this.props.categ) {
      this.fetchCardList(nextprops.categ + '-cards');
    }
    return true;
  }

  componentDidMount () {
    if (this.props.categoryid != null) {
      this.fetchCardList(this.props.categoryid);
    }
    else if (this.props.categ != null) {
      this.fetchCardList(this.props.categ + '-cards');
    }
    else {
      this.fetchCardList(100)
      this.fetchCardList(110)
      this.fetchCardList(120)
      this.fetchCardList(125)
      this.fetchCardList(150)
      this.fetchCardList(170)
      this.fetchCardList(200)
      this.fetchCardList(300)
      this.fetchCardList(400)
      this.fetchCardList(500)
      this.fetchCardList(510)
      this.fetchCardList(550)
      this.fetchCardList(600)
      this.fetchCardList(650)
      this.fetchCardList(670)
      this.fetchCardList(700)
      this.fetchCardList(800)
      this.fetchCardList(900)
    }
  }

  fetchCardList(id)
  {
    const stateKey = 'cardList' + id;
    fetch(`${API_ROOT}/cards/categ/${id}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })
    .then ( response => {
      if ( response.ok ) {
        return response.json()
      }
    })
    .then (data => {
      this.setState({isLoading:false})
      if (this.props.categoryid != null || this.props.categ != null) {
        this.setState({cardList:this.renderCardGrid(data)})
        this.setState({categoryName:data.category_name})
        this.setState({categoryDesc:data.category_description})
      }
      else {
        this.setState({[stateKey]:this.renderCardGrid(data)});
      }
    })
    .catch((error) =>{
      //console.error(error);
    })
  }

  lcShow(image, link, name, price, categoryid) {
    this.setState({ lcShow: true })
    this.setState({ lcImage: image })
    this.setState({ lcLink: link })
    this.setState({ lcName: name })
    this.setState({ lcPrice: price })
    this.setState({ lcFormattedPrice: 'RM' + new Intl.NumberFormat('ms-MY', {minimumFractionDigits: 2}).format(price) })
    this.setState({ lcCategoryId: categoryid })
  }

  lcCheck() {
    if (this.state.lcShow === true) {
      this.setState({ lcShow: false })
    }
  }

  renderCardGrid(cardList) {
    let blocks = [];
    cardList.cards.forEach((card, index) => {
      let number = index + 1
      let formattedPrice = 'RM' + new Intl.NumberFormat('ms-MY', {minimumFractionDigits: 2}).format(card.price)
      let cardUrl = '/cards/' + card.card_id
      if (cardList.category_seo_url !== '' && card.card_seo_url !== '') {
        cardUrl = '/' + cardList.category_seo_url + '/' + card.card_seo_url
      }
      blocks.push(
        <Col xs={6} sm={3} md={3} lg={2} key={"col" + index}>
          <div className="card-box" onClick={() => this.lcShow(card.large_image, cardUrl, card.card_name, card.price, card.category_id)}>
            <Image src={card.small_image} alt={card.card_name + " greeting card"}
            title={"Send this greeting card " + card.card_name} responsive />
            <div className="card-name">{card.card_name}</div>
            <div>
            {card.category_id === 12555555 ? (
                <React.Fragment>
                <span><del>RM9.90</del> </span>
                <span style={{color: '#ff7878'}}><b>{formattedPrice}</b></span>
                </React.Fragment>
            ):(
              <span className="card-price">{formattedPrice}</span>
            )}
            </div>
          </div>
        </Col>
      )

      if(number%2 === 0)
      {
        blocks.push(
          <Clearfix visibleXsBlock key={"cfxs" + index}></Clearfix>
        )
      }

      if(number%4 === 0)
      {
        blocks.push(
          <Clearfix visibleMdBlock key={"cfmd" + index}></Clearfix>
        )
        blocks.push(
          <Clearfix visibleSmBlock key={"cfsm" + index}></Clearfix>
        )
      }

      if(number%6 === 0)
      {
        blocks.push(
          <Clearfix visibleLgBlock key={"cflg" + index}></Clearfix>
        )
      }
    })
    return blocks;
  }

  renderHeaderMeta() {

    if (this.props.categoryid === 100 || this.props.categ === 'mothers-day') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/mothers-day-cards" />
          <meta name="description" content="Happy Mother's Day, Mother's Day cards for your mom"></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 110 || this.props.categ === 'teachers-day') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/teachers-day-cards" />
          <meta name="description" content="Happy Teachers' Day! Personalized Teachers' Day cards for your teachers."></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 120 || this.props.categ === 'cny') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/cny-cards" />
          <meta name="description" content="Happy Chinese New Year, Gong Xi Fa Cai, we mail Chinese New Year cards and your CNY wishes to family and friends."></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 125 || this.props.categ === 'hari-raya') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/hari-raya-cards" />
          <meta name="description" content="Hari Raya greeting cards Malaysia"></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 150 || this.props.categ === '中秋节-Mid-autumn-festival') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/中秋节-Mid-autumn-festival-cards" />
          <meta name="description" content="Personalized mid autumn festival greeting cards Malaysia, we mail your wishes."></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 170 || this.props.categ === 'christmas') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/christmas-cards" />
          <meta name="description" content="Send holiday wishes to family and friends with personalized Christmas greeting cards, Merry Christmas & Happy New Year"></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 200 || this.props.categ === 'fathers-day') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/fathers-day-cards" />
          <meta name="description" content="Personalized Father's Day card for your dad. Happy Father's Day!"></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 300 || this.props.categ === 'thank-you') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/thank-you-cards" />
          <meta name="description" content="Personalized thank you card Malaysia, we mail your thank you note."></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 400 || this.props.categ === 'birthday') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/birthday-cards" />
          <meta name="description" content="Personalized birthday wishes for someone you care about, we mail your birthday wishes"></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 500 || this.props.categ === 'love') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/love-cards" />
          <meta name="description" content="Romantic love &amp; valentine&#39;s day card for someone special, we mail your beautiful love messages"></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 510 || this.props.categ === 'social-distancing' || this.props.categ === 'long-distance') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/social-distancing-cards" />
          <meta name="description" content="Send your love, hugs and whishes while socail distancing/lockdown"></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 550) {
      return (
        <Helmet>
          <meta name="description" content="Make your friends smile with personalized friendship card"></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 700 || this.props.categ === 'new-baby') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/new-baby-cards" />
          <meta name="description" content="Welcome new baby, congratulations on your family and friends new baby"></meta>
        </Helmet>
      )
    }
    else if (this.props.categoryid === 800 || this.props.categ === 'farewell') {
      return (
        <Helmet>
          <link rel="canonical" href="https://www.naleycards.com/farewell-cards" />
          <meta name="description" content="Farewell cards Malaysia, good bye, good luck & thank you"></meta>
        </Helmet>
      )
    }
  }

  setDocumentTitle () {
    let siteName = ' - NaleyCards'
    if ( this.props.categoryid === 100 || this.props.categ === "mothers-day" ) {
      document.title = 'Mother\'s Day Cards Malaysia' + siteName
    }
    else if ( this.props.categoryid === 110 || this.props.categ === 'teachers-day' ) {
      document.title = 'Teachers\' Day Cards Malaysia' + siteName
    }
    else if ( this.props.categoryid === 120 || this.props.categ === 'cny' ) {
      document.title = 'Chinese New Year Cards ' + siteName
    }
    else if ( this.props.categoryid === 125 || this.props.categ === 'hari-raya' ) {
      document.title = 'Hari Raya Cards ' + siteName
    }
    else if ( this.props.categoryid === 150 || this.props.categ === '中秋节-Mid-autumn-festival' ) {
      document.title = '中秋节 Cards, Mid Autumn Festival Cards' + siteName
    }
    else if ( this.props.categoryid === 170 || this.props.categ === "christmas" ) {
      document.title = 'Christmas Greeting Cards' + siteName
    }
    else if ( this.props.categoryid === 200 || this.props.categ === "fathers-day" ) {
      document.title = 'Father\'s Day Cards Malaysia' + siteName
    }
    else if ( this.props.categoryid === 300 || this.props.categ === 'thank-you' ) {
      document.title = 'Thank You Cards & Greeting, Show Your Appreciation With A Heartfelt Thank You Note' + siteName
    }
    else if ( this.props.categoryid === 400 || this.props.categ === 'birthday' ) {
      document.title = 'Birthday Greeting Cards Malaysia' + siteName
    }
    else if ( this.props.categoryid === 500 || this.props.categ === 'love') {
      document.title = 'Love and Valentine\'s Day Cards, We Mail Your Love Messages' + siteName
    }
    else if ( this.props.categoryid === 510 || this.props.categ === 'love') {
      document.title = 'Social Distancing Cards' + siteName
    }
    else if ( this.props.categoryid === 550 ) {
      document.title = 'Friendship Cards, Let Your Friend Know How Much You Love Them' + siteName
    }
    else if ( this.props.categoryid === 600 ) {
      document.title = 'Sympathy Cards Malaysia' + siteName
    }
    else if ( this.props.categoryid === 650 ) {
      document.title = 'Sorry Cards Malaysia' + siteName
    }
    else if ( this.props.categoryid === 670 ) {
      document.title = 'Get Well Soon Cards' + siteName
    }
    else if ( this.props.categoryid === 700 || this.props.categ === 'new-baby' ) {
      document.title = 'New Baby Cards, Congratulations On New Baby' + siteName
    }
    else if ( this.props.categoryid === 800 || this.props.categ === 'farewell' ) {
      document.title = 'Farewell Cards' + siteName
    }
    else if ( this.props.categoryid === 900 ) {
      document.title = 'Congratulations Cards' + siteName
    }
    else {
      document.title = 'Greeting Cards' + siteName
    }
  }

  render() {
    this.setDocumentTitle()
    return (
<Grid onClick={() => this.lcCheck()} >
  {this.renderHeaderMeta()}
  <Modal show={this.state.lcShow} className="modal">
    <Modal.Header closeButton>
      <center>
        <span className="card-button"><Link to={this.state.lcLink} title={"Send this greeting card " + this.state.lcName}>
        <Button>Send this card</Button></Link></span>
      </center>
    </Modal.Header>
    <Modal.Body className="modal-body">
      <center><span> {this.state.lcName} Card - </span>
        {this.state.lcCategoryId === 12555555 ? (
          <React.Fragment>
          <span><del>RM9.90</del> </span>
          <span style={{color: '#ff7878'}}><b>{this.state.lcFormattedPrice}</b></span>
          </React.Fragment>
        ) : (
          <span>{this.state.lcFormattedPrice}</span>
        )}
      </center>
      <Image src={this.state.lcImage} alt={this.state.lcName + " greeting card"} responsive />
    </Modal.Body>
  </Modal>

  {this.props.categoryid != null || this.props.categ != null ? (
    <React.Fragment>
    <Row>
      <Col xs={12} sm={12} md={12} lg={12}>
      {this.props.categoryid === 12000000 || this.props.categ === 'cnyyyy' ? (
        <div className="cards-subject">
          <Link to="/cards">Cards </Link><span style={{color: '#ff7878'}}> / {this.state.categoryName} Cards (40% OFF)</span>
        </div>
      ):(
        <div className="cards-subject">
          <Link to="/cards">Cards </Link> / {this.state.categoryName} Cards
        </div>
      )}
      </Col>
    </Row>
    {this.state.categoryDesc !== '' && (
    <Row>
      <Col xs={12} sm={12} md={12} lg={12}><div className="card-categ-desc">{this.state.categoryDesc}</div></Col>
    </Row>
    )}
    <Row>
      {this.state.isLoading === true && (
        <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
      )}
      {this.state.cardList}
    </Row>
    </React.Fragment>
    ):(
      <React.Fragment>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/hari-raya-cards" title="Hari Raya Greeting Cards Malaysia">Hari Raya Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList125}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/birthday-cards" title="Birthday Greeting Cards Malaysia">Birthday Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList400}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/mothers-day-cards" title="Mother&#39;s Day Card Malaysia">
              Mother&#39;s Day Cards
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList100}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/fathers-day-cards" title="Father&#39;s Day Cards Malaysia">
              Father&#39;s Day Cards
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList200}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/thank-you-cards" title="Thank You Cards Malaysia">Thank You Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList300}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/new-baby-cards" title="New Baby Cards Malaysia">New Baby Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList700}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/中秋节-Mid-autumn-festival-cards" title="中秋节 Cards Malaysia">中秋节 Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList150}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
          {/*<Link to="/cny-cards" style={{color: '#ff7878'}} title="Chinese New Year Cards Malaysia">Chinese New Year Cards (40% OFF)</Link>*/}
          <Link to="/cny-cards" title="Chinese New Year Cards Malaysia">Chinese New Year Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList120}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            {/*<Link to="/christmas-cards" style={{color: '#ff7878'}} title="Christmas Greeting Cards Malaysia">Christmas Cards (Early Bird Promotion 40% OFF)</Link>*/}
            <Link to="/christmas-cards" title="Christmas Greeting Cards Malaysia">Christmas Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList170}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/social-distancing-cards" title="Social Distancing Cards">Social Distancing Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList510}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/teachers-day-cards" title="Teachers' Day Greeting Cards Malaysia">Teachers' Day Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList110}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/love-cards" title="Love And Valentine&#39;s Day Card Malaysia">
              <span style={{color: '#ee82ee'}}><b>Love &amp; Valentine&#39;s Day Cards</b></span>
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList500}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/category/550" title="Friendship Cards Malaysia">Friendship Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList550}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/category/900" title="Congratulations Cards Malaysia">Congratulations Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList900}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="farewell-cards" title="Farewell Cards Malaysia">Farewell Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList800}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/category/670" title="Get Well Soon Cards Malaysia">Get Well Soon Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList670}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/category/600" title="Sympathy Cards Malaysia">Sympathy Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList600}
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="cards-subject">
            <Link to="/category/650" title="Sorry Cards Malaysia">Sorry Cards</Link>
          </div>
        </Col>
      </Row>
      <Row>
        {this.state.isLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.cardList650}
      </Row>

      </React.Fragment>
    )}

</Grid>

    )
  }
}

export default Cards;
